export default {
  subcategories: [],
  entities: [],
}
